<template>
  <div>
    <section class="section auth-ui-section--has-margin-top auth-ui-section--is-narrow">
      <div class="container auth-ui-container--has-centered-content">
        <v-card :classes="'auth-ui-card--is-not-full-width'">
          <div slot="header-title">
            {{ $t('auth.requestVerificationLinkTitle') }}
          </div>
          <form slot="body">
            <div class="auth-ui-form-description">
              {{ $t('auth.requestVerificationLinkDescription') }}
              <div class="auth-ui-form-description-email">
                {{ email }}
              </div>
            </div>

            <div class="field is-grouped is-grouped-centered auth-ui-field--has-margin-top">
              <div class="control auth-ui-button-and-spinner-container">
                <button
                  :disabled="buttonIsDisabled"
                  class="button is-link auth-ui-button"
                  @click.prevent="sendVerificationLink()"
                >
                  {{ $t('auth.requestVerificationLinkButton') }}
                </button>
              </div>
            </div>

            <article
              v-if="serverResponse.visible"
              class="auth-ui-card__message-container"
            >
              <div
                :class="{'is-danger': serverResponse.error, 'is-success': !serverResponse.error }"
                class="message"
              >
                <div class="message-body">
                  <button
                    class="delete auth-ui-delete--is-high"
                    aria-label="delete"
                    @click="closeMessage()"
                  />
                  <span>
                    {{ serverResponse.message }}
                  </span>
                </div>
              </div>
            </article>
          </form>
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
/* ============
       * Verify Email Page
       * ============
       *
       * Page where a logged in user can request an email verification link.
       */

import Request from '../../tools/Request';
import QueryStringTool from '../../tools/QueryStringTool';
import UserInfoTool from '../../tools/UserInfoTool';
import VCard from '../../components/Card.vue';

export default {
  name: 'AuthRequestVerificationLink',

  components: {
    VCard,
  },

  data() {
    return {
      email: UserInfoTool.getUserInfo().email,
      buttonPressed: false, // eliminates button spam
      errors: {
        email: false,
        password: false,
      },
      serverResponse: {
        message: '',
        visible: false,
        error: false,
      },
      title: process.env.VUE_APP_PAGE_TITLE,
      buttonIsDisabled: false,
    };
  },

  methods: {

    clearErrorFromField(fieldName) {
      this.errors[fieldName] = false;
    },

    validateEmail() {
      // eslint-disable-next-line
      const regEx = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      this.errors.email = !regEx.test(this.email.toLocaleLowerCase());
    },

    closeMessage() {
      this.serverResponse.visible = false;
    },

    showMessage(message = '', error = false) {
      this.serverResponse.visible = true;
      this.serverResponse.error = error;
      this.serverResponse.message = message;
    },

    async sendVerificationLink() {
      this.validateEmail();

      if (!this.buttonPressed) {
        this.buttonPressed = true;
        this.toggleShowSpinner(true);
        this.closeMessage();

        let target = process.env.VUE_APP_AFTER_REGISTER_URL ? process.env.VUE_APP_AFTER_REGISTER_URL : QueryStringTool.getQueryStringStartFromParam('target');
        // use customer's root path as last resort
        target = target !== null ? target : `https://${process.env.VUE_APP_HOST}/`;

        try {
          await Request.submit(
            'POST',
            `${process.env.VUE_APP_BACKEND_URL}/send_verification_link`,
            { target },
          );

          this.buttonIsDisabled = true;
          this.showMessage(this.$t('auth.requestVerificationLinkSuccess'));
          this.toggleShowSpinner(false);
        } catch (error) {
          this.toggleShowSpinner(false);
          if (error === 'Unauthorized') {
            await this.$router.push({ name: 'auth.sign.in' });
          } else if (error === 'Forbidden') {
            this.showMessage(this.$t('auth.requestVerificationLinkAlreadyVerifiedError'), true);
          } else {
            this.buttonPressed = false;
            this.showMessage(this.$t('auth.requestVerificationLinkError'), true);
          }
        }
      }
    },

    /**
     * Toggles the app-wide spinner state in Vuex store.
     */
    toggleShowSpinner(isVisible = true) {
      this.$store.dispatch('general/setShowSpinner', isVisible);
    },
  },
};
</script>
